module.exports = __webpack_public_path__ + "static/assets/6bad8d2cf8533163b78c1312122e65e8.png";